/* @flow */
import * as React from 'react';
import Modal from 'react-modal';

import Button from 'components/Button';
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import DisableRepliesConfirmationDialog from 'chat/components/DisableRepliesConfirmationDialog';
import Glyph from 'components/Glyph';

export type Props = { chat: Chat, buttonClassName?: string };
type State = { disableRepliesModalOpen: boolean };

class ManageChatButton extends React.Component<Props, State> {
  state = {
    disableRepliesModalOpen: false,
  };

  hideModal = () => this.setState({ disableRepliesModalOpen: false });

  showModal = () => this.setState({ disableRepliesModalOpen: true });

  renderDisabledRepliesButton() {
    const { chat } = this.props;

    return (
      <React.Fragment>
        <Modal isOpen={this.state.disableRepliesModalOpen}>
          <DisableRepliesConfirmationDialog chat={chat} onRequestHide={this.hideModal} />
        </Modal>
        <Button
          onClick={this.showModal}
          level="text"
          weight="semibold"
          className={this.props.buttonClassName}
          data-test="disable-reply-button">
          <Glyph
            name="chat-close-bubble-fill"
            size="large"
            data-test-selector="conversation-sidebar-disable-replies"
          />
          <span data-test="disable-reply-text">Turn off replies</span>
        </Button>
      </React.Fragment>
    );
  }

  renderEnabledRepliesButton() {
    const { chat } = this.props;

    const buttonProps = {};
    if (chat.canOpen()) {
      buttonProps.onClick = () => ChatActions.enableReplies(chat);
    } else {
      buttonProps.disabled = true;
      // If can_send is false, we assume this thread has an under13 user.
      if (!chat.canSend()) {
        Object.assign(buttonProps, {
          // There is a bug in Chrome where disabled form elements don't properly fire mouseleave
          // events. This was breaking tooltip behavior. To fix, just make the button a link.
          href: '#',
          tooltip: 'Two-way messaging is not permitted with students under the age of 13.',
          tooltipPlacement: 'bottom',
        });
      }
    }

    return (
      <Button
        className={this.props.buttonClassName}
        level="text"
        weight="semibold"
        data-test="enable-reply-button"
        {...buttonProps}>
        <Glyph
          name="chat-check-bubble-fill"
          size="large"
          data-test-selector="conversation-sidebar-enable-replies"
        />
        <span data-test="enable-reply-text">Turn on replies</span>
      </Button>
    );
  }

  renderManagedButton() {
    const { chat } = this.props;

    // The chat be open with can_send false (for under 13 users)
    if (chat.isOpen() && chat.canSend()) {
      return this.renderDisabledRepliesButton();
    } else {
      return this.renderEnabledRepliesButton();
    }
  }

  render() {
    const { chat } = this.props;

    if (!chat.canManageReplies()) {
      return null;
    }

    return <div className="ManageChatButton">{this.renderManagedButton()}</div>;
  }
}

export default ManageChatButton;
